export default __webpack_public_path__ + "static/media/DownstairsHall.ade59916.png";